import './style.less';
import { Image } from './image';
export { ImageProps } from './PropsType';
export default Image;
